import React from 'react'
import { Grid } from 'semantic-ui-react'

const Bio = () => {
  return(
    <Grid.Row >
      <Grid.Column width={8}>
        <p id="bio"> Lifelong learner and educator <br/> Integrating web development with education </p>
        <p> If you want to work together or just have a chat, click an icon below</p>
      </Grid.Column>
    </Grid.Row>
  )
}

export default Bio



// WEBPACK FOOTER //
// ./src/Bio.js